import findIndex from 'lodash/findIndex';
import {connect} from 'react-redux';

import Timeline from '../components/timeline';
import {TIME_SLOTS} from '../config';

const START_SLOT = 0;
const END_SLOT = TIME_SLOTS.length - 1;

function timestampToTimeSlot(timestamp, end = 'start') {
	if (!timestamp) {
		return end === 'start' ? START_SLOT : END_SLOT;
	}

	const index = findIndex(
		TIME_SLOTS,
		({from, to}) => (!from || from <= timestamp) && (!to || to >= timestamp)
	);

	if (index > -1) {
		return end === 'start' ? index : Math.min(index + 1, END_SLOT);
	} else {
		return end === 'start' ? START_SLOT : END_SLOT;
	}
}

function timeSlotToTimestamp(timeSlot, end = 'from') {
	return TIME_SLOTS[timeSlot][end] || null;
}

export default connect(
	(state) => ({
		start: timestampToTimeSlot(state.app.startTimestamp, 'start'),
		end: timestampToTimeSlot(state.app.endTimestamp, 'end'),
		steps: TIME_SLOTS.map(({label}) => label),
	}),
	(dispatch) => ({
		setStart: (timeSlot) =>
			dispatch({
				type: 'SET_START_TIMESTAMP',
				startTimestamp: timeSlotToTimestamp(timeSlot, 'from'),
			}),
		setEnd: (timeSlot) =>
			dispatch({
				type: 'SET_END_TIMESTAMP',
				endTimestamp: timeSlotToTimestamp(timeSlot - 1, 'to'),
			}),
	})
)(Timeline);
